const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '商机ID',
      dataIndex: 'id',
      render: 'businessIdRender',
      width: 200,
      fixed: 'left',
    },
    {
      title: '楼盘',
      dataIndex: 'buildingName',
      width: 230,
      ellipsis: true,
      render: (text: string) => text || '-',
    },
    {
      title: '商机状态',
      dataIndex: 'statusDesc',
      width: 160,
      render: 'statusRender',
    },
    {
      title: '销售阶段',
      dataIndex: 'currentNodeName',
      width: 200,
      render: 'saleStageRender',
    },
    {
      title: '需求标签',
      dataIndex: 'bizTypeName',
      width: 150,
      render: 'demandTagRender',
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 150,
    },
    {
      title: '设计师',
      dataIndex: 'designer',
      width: 150,
      render: (text: string) => text || '-',
    },
  ],
  footer: false,
}

export default config
